// Analytics utility for Consent Mode V2
import ReactGA from 'react-ga4';
import { isAnalyticsEnabled, getStoredConsent } from './consentManager';

const TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID || 'G-4LBBG5J11B';
const isProduction = process.env.NODE_ENV === 'production';

let isInitialized = false;

// Initialize Google Analytics (simplified for Consent Mode V2)
export const initGA = (hasAnalyticsConsent = false) => {
    // With Consent Mode V2, GA initialization is handled automatically
    // based on the consent state, so we just need to check if analytics is enabled
    if (isProduction && hasAnalyticsConsent && TRACKING_ID) {
        isInitialized = true;
        console.log('Analytics consent granted - GA will track via Consent Mode V2');
    }
};

// Track page views using gtag directly (works with Consent Mode V2)
export const trackPageView = (path) => {
    if (isProduction && window.gtag) {
        // Use gtag directly for better Consent Mode V2 integration
        window.gtag('event', 'page_view', {
            page_title: document.title,
            page_location: window.location.href,
            page_path: path
        });
    }
};

// Check if analytics is enabled based on current consent state
export const isGAInitialized = () => {
    const currentConsent = getStoredConsent();
    return isAnalyticsEnabled(currentConsent);
};

// Disable analytics (update consent to denied)
export const disableGA = () => {
    const { updateConsentMode, DEFAULT_CONSENT_STATE } = require('./consentManager');
    updateConsentMode(DEFAULT_CONSENT_STATE);
    isInitialized = false;
    console.log('Analytics disabled via Consent Mode V2');
};

/* Track custom events
export const trackEvent = (eventName, parameters = {}) => {
  if (isProduction) {
    ReactGA.event(eventName, parameters);
  }
};*/

/* Predefined event tracking functions
export const trackButtonClick = (buttonName, location = '') => {
  trackEvent('button_click', {
    button_name: buttonName,
    location: location
  });
};

export const trackFormSubmission = (formName) => {
  trackEvent('form_submit', {
    form_name: formName
  });
};

export const trackDownload = (fileName) => {
  trackEvent('file_download', {
    file_name: fileName
  });
};

export const trackSearch = (searchTerm) => {
  trackEvent('search', {
    search_term: searchTerm
  });
};*/